var _ellipse, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: 11.5,
    rx: 11.5,
    ry: 11.5,
    transform: "rotate(90 11.5 11.5)",
    fill: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2728 15.5624C9.00368 15.5624 7.9707 14.5294 7.9707 13.2603V7.70825H7.02282C6.2011 7.70825 5.5332 8.37604 5.5332 9.19777V16.5103C5.5332 17.332 6.2011 17.9999 7.02282 17.9999H13.7936C14.6153 17.9999 15.2832 17.332 15.2832 16.5103V15.5624H10.2728Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4498 6.48962C17.4498 5.6668 16.783 5 15.9603 5H10.2728C9.45 5 8.7832 5.6668 8.7832 6.48962V13.2604C8.7832 14.0832 9.45 14.75 10.2728 14.75H15.9603C16.783 14.75 17.4498 14.0832 17.4498 13.2604V6.48962Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3be104b5.svg";
export { ForwardRef as ReactComponent };